import { render, staticRenderFns } from "./WaMessageDetail.vue?vue&type=template&id=10607b01&scoped=true&"
import script from "./WaMessageDetail.vue?vue&type=script&lang=js&"
export * from "./WaMessageDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaMessageDetail.vue?vue&type=style&index=0&id=10607b01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10607b01",
  null
  
)

export default component.exports